


























import axios from "axios";
//import VueSimpleSuggest from "vue-simple-suggest";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    //VueSimpleSuggest
  }
})
export default class SuggestPanel extends Vue {
  @Prop({ type: String, required: true }) value!: string;
  @Prop({ type: String, required: true }) type!: string;
  query = "";
  styles: Record<string, any> = {
    vueSimpleSuggest: "p-suggest-panel",
    inputWrapper: "p-suggest-panel__input_wrapper",
    suggestions: "p-suggest-panel__suggestions",
    suggestItem: "p-suggest-panel__suggest_item"
  };

  getSuggestionList() {
    //const self = this;
    const postData = {
      query: this.value,
      type: this.type
    };

    return axios
      .post("/api/admin/suggest/", postData)
      .then(response => response.data)
      .catch(error => {
        // TODO: エラー対応
      });
  }
}
